import API from "components/Apis/API";
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import toast from "react-hot-toast";

export const allColors = {
  incomingBuses: { light: "#A1c09A", dark: "#8aad7f", text: "#367326" },
  outgoingBuses: { light: "#fed097", dark: "#e8b572", text: "#bf6f09" },
  incomingOrders: { light: "#b898c1", dark: "#a889ae", text: "#663d71" },
  outgoingOrders: { light: "#c09a99", dark: "#ae8585", text: "#7c3838" },
};

export const makeProNumber = (item) => {
  return item.order_no + " " + item.order_group + " " + item.pro_f;
};

export const cleanDelivery = (item) => {
  return item.replace(/\([^)]*\bCONTINENTAL\b[^)]*\)/g, "");
};

function makeDatetimeObject(datestring) {
  datestring = datestring.replace(/\s+/g, "");
  const regex = /^(\d{2})\/(\d{2})(\d{2})(\d{2})$/;
  const match = datestring.match(regex);
  if (match) {
    const month = parseInt(match[1], 10);
    const day = parseInt(match[2], 10);
    const hours = parseInt(match[3], 10);
    const minutes = parseInt(match[4], 10);
    const date = new Date(
      new Date().getFullYear(),
      month - 1,
      day,
      hours,
      minutes
    );
    if (!isNaN(date.getTime())) {
      return date;
    }
  }
  return null;
}

export const getFilteredData = (data, filters, display) => {
  const filtered = data.filter((item) => {
    const searchText = filters.searchText
      ? filters.searchText.toLowerCase()
      : "";
    const proNumber = makeProNumber(item);
    const findMatch = (value) => {
      try {
        const escapedSearchText = searchText.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&"
        );
        const regex = new RegExp(escapedSearchText, "i");
        return regex.test(value);
      } catch (error) {
        console.log("error in the matching", error);
        return false;
      }
    };

    const matchesSearchText =
      searchText === "" ||
      findMatch(item.inbound) ||
      findMatch(item.dock, searchText) ||
      findMatch(proNumber) ||
      findMatch(item.bus) ||
      findMatch(item.units) ||
      findMatch(item.weight) ||
      findMatch(item.vehicle_size) ||
      findMatch(item.bus_status) ||
      findMatch(item.deliver_to) ||
      findMatch(item.scheduled_pickup) ||
      findMatch(item.drop_dead) ||
      findMatch(item.notes);

    let matchesFilters = matchesSearchText;
    if (filters.orderType === "dock") {
      const datetimeObject = makeDatetimeObject(item.dock);
      const now = new Date();
      matchesFilters =
        matchesFilters &&
        ((datetimeObject && datetimeObject <= now) ||
          item.dock.toLowerCase() === "yes" ||
          item.dock.toLowerCase() === "on site");
    } else if (filters.orderType === "bus" && display === "Outgoing") {
      matchesFilters =
        matchesFilters &&
        item.bus &&
        (item.bus.startsWith("LN") ||
          item.bus.startsWith("CS") ||
          item.bus.startsWith("CN") ||
          item.bus.startsWith("DS") ||
          item.bus.startsWith("DN"));
    } else if (filters.orderType === "direct" && display === "Outgoing") {
      matchesFilters =
        matchesFilters &&
        (!item.bus ||
          (!item.bus.startsWith("LN") &&
            !item.bus.startsWith("CS") &&
            !item.bus.startsWith("CN") &&
            !item.bus.startsWith("DN") &&
            !item.bus.startsWith("DS")));
    } else if (filters.orderType === "bus" && display === "Incoming") {
      matchesFilters =
        matchesFilters && item.inbound && item.inbound.startsWith("B-");
    } else if (filters.orderType === "direct" && display === "Incoming") {
      matchesFilters =
        matchesFilters && (!item.inbound || !item.inbound.startsWith("B-"));
    }
    else if (filters.orderType === "partial") {
      matchesFilters =
        matchesFilters && (item.is_partial)
    }
    return matchesFilters
  })
  return filtered
}

export const handleSort = (
  col,
  sortColumn,
  setSortColumn,
  sortDirection,
  setSortDirection,
  data
) => {
  let direction = "asc";
  if (col === sortColumn && sortDirection === "asc") {
    direction = "desc";
  }
  const sortedData = [...data].sort((a, b) => {
    const valueA = String(a[col]).toLowerCase();
    const valueB = String(b[col]).toLowerCase();
    if (valueA === "") {
      return direction === "asc" ? 1 : -1;
    }
    if (valueB === "") {
      return direction === "asc" ? -1 : 1;
    }
    if (valueA < valueB) return direction === "asc" ? -1 : 1;
    if (valueA > valueB) return direction === "asc" ? 1 : -1;
    return 0;
  });
  setSortColumn(col);
  setSortDirection(direction);
  return sortedData;
};

export const handleNotesUpdate = async (id, notes) => {
  const url = "" + "admin/update_notes";
  let formData = new FormData();
  formData.append("id", id);
  formData.append("notes", notes);
  const responseMessage = await API.postData(url, formData);
};

export const handleContactUpdate = async (id, contact) => {
  const url = "" + "admin/update_dock"
  let formData = new FormData()
  formData.append("id", id)
  formData.append("dock", contact)
  const responseMessage = await API.postData(url, formData)
}

const colorMappings = [
  { backgroundColor: "rgba(164, 36, 59, 0.5)" },
  { backgroundColor: "rgba(12, 206, 107, 0.5)" },
  { backgroundColor: "rgba(230, 136, 28, 0.5)" },
];

export const scheduledPickupColor = (scheduledPickup) => {
  if (!scheduledPickup) {
    return;
  } else {
    const targetDate = new Date(scheduledPickup);
    const now = new Date();
    const isSameDay =
      targetDate.getDate() === now.getDate() &&
      targetDate.getMonth() === now.getMonth() &&
      targetDate.getFullYear() === now.getFullYear();
    if (targetDate < now) {
      return colorMappings[0];
    } else if (isSameDay) {
      return colorMappings[1];
    } else {
      return colorMappings[2];
    }
  }
};

export const onDockColor = (onDock) => {
  if (!onDock) {
    return null;
  }
  const formattedOnDock = onDock.replace(/\s/g, "");
  if (
    formattedOnDock.toLowerCase() === "yes" ||
    formattedOnDock.toLowerCase() === "onsite"
  ) {
    return colorMappings[1];
  }
  const now = new Date();
  const dateMatch = formattedOnDock.match(/^(\d{1,2}\/\d{1,2})(\d{4})$/);
  if (dateMatch) {
    const [, monthDay, time] = dateMatch;
    const [month, day] = monthDay.split("/");
    const currentYear = now.getFullYear();
    const formattedDate = new Date(currentYear, month - 1, day);
    const hours = parseInt(time.slice(0, 2), 10);
    const minutes = parseInt(time.slice(2), 10);
    formattedDate.setHours(hours, minutes);
    const isSameDay =
      formattedDate.getDate() === now.getDate() &&
      formattedDate.getMonth() === now.getMonth() &&
      formattedDate.getFullYear() === now.getFullYear();
    if (formattedDate < now) {
      return colorMappings[0];
    } else if (isSameDay) {
      return colorMappings[1];
    } else {
      return colorMappings[2];
    }
  }
};

export const makeNiceDate = (dateTime) => {
  const date = new Date(dateTime);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${month}/${day}, ${hours}:${minutes}`;
};

export const getOrderHistory = async (
  order_id,
  searchText,
  setHistoryData
) => {
  const url = "" + "admin/get_order_history";
  let formData = new FormData();
  formData.append("order_id", order_id);
  formData.append("searchText", searchText);
  const responseData = await API.postData(url, formData);
  setHistoryData(responseData);
};

export const OrderHistory = ({ row }) => {
  const [showOrderHistory, setShowOrderHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (showOrderHistory) {
      const toastId = toast.loading("Fetching history...");
      getOrderHistory(
        row.id,
        searchText,
        setHistoryData
      )
        .then(() => {
          toast.dismiss(toastId);
        })
    }
  }, [showOrderHistory, row.id, searchText]);

  const handleCloseModal = () => setShowOrderHistory(false);

  return (
    <>
      <div
        style={{ cursor: "pointer" }}
        className="order-history-link"
        onClick={() =>
          setShowOrderHistory(true)
        }
      >
        Updated by{" "}
        {
          row.updated_by_username?.startsWith("atiq")
            ? "System"
            : row.updated_by_username?.split("@")[0]
        }
      </div>
      <Modal
        className="warehouse-order-history"
        show={showOrderHistory}
        onHide={handleCloseModal}
      >
        <Modal.Header>
          {/* <Modal.Title>{makeProNumber(row)} - Order Line History</Modal.Title> */}
          <Modal.Title>
            <div style={{ position: "relative" }}>
              <input
                className="history-search-input"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.key == 'Tab') {
                    setSearchText(e.target.value);
                  }
                }}
                placeholder={`Search ${makeProNumber(row)} Order History`}
                style={{
                  paddingLeft: "46px" // Add padding to make room for the icon
                }}
              />
              <div
                style={{
                  color: "#aaa",
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  pointerEvents: "none" // Makes the icon non-interactive
                }}
              >
                <i className="fa fa-search" />
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table className="order-history-table" striped hover>
            <thead>
              <th>Order No</th>
              <th>Action</th>
              <th>Date</th>
              <th>User</th>
            </thead>
            <tbody>
              {historyData.map((item, index) => (
                <tr key={index}>
                  <td>{item.order_no} {item.order_group} {item.backorder}</td>
                  <td>{item.message}</td>
                  <td>{makeNiceDate(item.updated_at)}</td>
                  <td>
                    {item.username.startsWith("atiq")
                      ? "System"
                      : item.username?.split("@")[0]}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <button className="button" variant="secondary" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const handleTrailerComment = async (id, comment) => {
  const url = "" + "admin/update_trailer_comment";
  let formData = new FormData();
  formData.append("id", id);
  formData.append("comment", comment);
  const response = await API.postData(url, formData);
};

export const whatIsRowType = (row) => {
  const dictKeys = Object.keys(row);
  if (dictKeys.includes('master_pro')) {
    return 'order'
  }
  else if (dictKeys.includes('name')) {
    return 'bus'
  }
  else {
    return 'partial'
  };
}

export function isOrderAPartialableByBusNamingConvention(order) {
  let busNomenclaturePatterns;

  const bus = order.bus;
  const terminal = order.terminal;

  // Determine patterns based on the terminal
  switch (String(terminal)) {
    case "1": // "LRD NBB"
      busNomenclaturePatterns = [/LP(\d)/];
      break;
    case "2": // "CKV SBB"
      busNomenclaturePatterns = [/CSP(\d)/];
      break;
    case "3": // "CKV NBB"
      busNomenclaturePatterns = [/CNP(\d)/];
      break;
    case "5": // "DTW SBB"
      busNomenclaturePatterns = [/DSP(\d)/];
      break;
    // add cases for any new terminals here
    default: // Default return all orders for any other id provided
      return null;
  }
  if (bus) {
    // Check if the bus matches any of the patterns
    for (const pattern of busNomenclaturePatterns) {
      const match = bus.match(pattern);
      if (match) {
        return match[1].toLowerCase(); // Return the captured value (digit or day)
      }
    }
  }

  return null; // No match found
}